export default __webpack_public_path__ + "static/media/earnings-call-recording-september-2025.af4ba2c1.mp3";